var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.783 174.508L126.953 157.548L158.143 173.298L126.953 192.668L95.783 174.508Z",
    fill: "#29A063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.313 8.5282C127.673 8.7882 142.583 10.3082 157.703 19.8682C173.073 29.5882 180.403 42.2082 183.993 48.5782C189.323 58.0482 198.373 74.1382 194.973 95.2882C194.443 98.6082 190.303 121.898 169.133 136.288C160.573 142.108 152.223 144.428 147.023 145.458C138.383 53.8483 119.503 29.0782 102.653 25.0882C91.5528 22.4582 74.9228 26.8082 76.5328 26.1682C91.1228 20.3082 105.713 14.4082 120.323 8.5282H120.313Z",
    fill: "#29A063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.873 140.638V156.968L128.473 174.518C128.423 173.938 128.363 173.358 128.313 172.778C127.533 163.918 127.083 155.208 126.953 146.668C138.963 141.618 150.973 136.578 162.983 131.528L160.873 140.638Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.953 226.868L95.783 209.018V174.508L126.953 192.668V226.868Z",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.143 208.698V173.298L126.953 192.668V226.868L158.143 208.698Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2229 63.7183L90.6429 81.5883C90.6429 81.5883 93.0729 49.5082 120.313 65.2482C147.553 80.9782 129.303 109.758 126.573 110.368C123.843 110.988 99.7129 118.538 97.9029 136.378C96.0829 154.228 96.6329 157.868 96.6329 157.868L128.483 174.508C128.483 174.508 126.153 153.318 138.063 151.798C143.853 151.058 153.753 148.688 160.883 140.628C173.313 126.588 169.783 94.2582 168.583 89.4382C159.913 55.0982 126.923 20.5182 94.8829 21.6382C92.1929 21.7282 82.1129 22.0882 72.5729 28.4982C71.2229 29.3982 69.8629 30.4382 68.5529 31.6282C55.6129 43.2282 55.2329 60.1283 55.2329 63.7183H55.2229Z",
    fill: "#B2E8C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.8c76cf87133887033f2248e2f738f38a.svg";
export { ForwardRef as ReactComponent };